"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRefineModal = exports.useRefineModalColumns = void 0;
const react_1 = require("react");
const hooks_1 = require("../../hooks");
const localization_1 = require("../../localization");
const store_1 = require("../../store");
const State = __importStar(require("../../store/state"));
const useRefineModalColumns = (additionalColumns) => {
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    const baseColumns = (0, react_1.useMemo)(() => [
        {
            label: t({ key: 'PRODUCT_EDITOR_TABLE_COLUMNS_SKU_ID' }),
            id: State.PRODUCT_EDITOR_TABLE_COLUMNS.SKU_ID,
            description: t({ key: 'DEFAULT' }),
        },
        {
            label: t({ key: 'PRODUCT_EDITOR_TABLE_COLUMNS_IMAGE' }),
            id: State.PRODUCT_EDITOR_TABLE_COLUMNS.IMAGE,
            description: t({ key: 'DEFAULT' }),
        },
        {
            label: t({ key: 'PRODUCT_EDITOR_TABLE_COLUMNS_NAME' }),
            id: State.PRODUCT_EDITOR_TABLE_COLUMNS.NAME,
            description: t({ key: 'DEFAULT' }),
        },
        {
            label: t({ key: 'PRODUCT_EDITOR_TABLE_COLUMNS_PRODUCT_ID' }),
            id: State.PRODUCT_EDITOR_TABLE_COLUMNS.PRODUCT_ID,
        },
        {
            label: t({ key: 'PRODUCT_EDITOR_TABLE_COLUMNS_DESCRIPTION' }),
            id: State.PRODUCT_EDITOR_TABLE_COLUMNS.DESCRIPTION,
        },
        {
            label: t({ key: 'PRODUCT_EDITOR_TABLE_COLUMNS_PRODUCT_GROUP' }),
            id: State.PRODUCT_EDITOR_TABLE_COLUMNS.PRODUCT_GROUP,
        },
        {
            label: t({ key: 'PRODUCT_EDITOR_TABLE_COLUMNS_CREATED_DATE' }),
            id: State.PRODUCT_EDITOR_TABLE_COLUMNS.CREATED_DATE,
        },
        {
            label: t({ key: 'PRODUCT_EDITOR_TABLE_COLUMNS_LAST_MODIFIED' }),
            id: State.PRODUCT_EDITOR_TABLE_COLUMNS.LAST_MODIFIED,
        },
        {
            label: t({ key: 'PRODUCT_EDITOR_TABLE_COLUMNS_TAXONOMY_CLASS' }),
            id: State.PRODUCT_EDITOR_TABLE_COLUMNS.CLASS,
        },
        {
            label: t({ key: 'PRODUCT_EDITOR_TABLE_COLUMNS_URL' }),
            id: State.PRODUCT_EDITOR_TABLE_COLUMNS.URL,
        },
        // descoped for MVP
        // {
        //   label: t({ key: 'PRODUCT_EDITOR_TABLE_COLUMNS_PRICE' }),
        //   id: State.PRODUCT_EDITOR_TABLE_COLUMNS.PRICE,
        // },
        {
            label: t({ key: 'PRODUCT_EDITOR_TABLE_COLUMNS_ACTIVE_STATUS' }),
            id: State.PRODUCT_EDITOR_TABLE_COLUMNS.ACTIVE_STATUS,
        },
    ], [t]);
    const columns = [...baseColumns, ...additionalColumns];
    const defaultColumns = (0, react_1.useMemo)(() => columns
        .filter(({ description }) => description === t({ key: 'DEFAULT' }))
        .map(({ id }) => id), [columns]);
    return { columns, defaultColumns };
};
exports.useRefineModalColumns = useRefineModalColumns;
const useRefineModal = ({ lsKey, additionalColumns = [], additionalDefaultColumnNames = [], }) => {
    const ls = (0, hooks_1.useLocalStorage)();
    const { columns, defaultColumns } = (0, exports.useRefineModalColumns)(additionalColumns);
    const organizations = (0, store_1.useSelectedOrganizationsIdsSelector)();
    const [activeColumns, setActiveColumns] = (0, react_1.useState)([
        State.PRODUCT_EDITOR_TABLE_COLUMNS.SKU_ID,
        State.PRODUCT_EDITOR_TABLE_COLUMNS.IMAGE,
        State.PRODUCT_EDITOR_TABLE_COLUMNS.NAME,
        ...additionalDefaultColumnNames,
    ]);
    const getCacheableColumns = (activeColumns) => {
        const staticTableColumns = Object.values(State.PRODUCT_EDITOR_TABLE_COLUMNS);
        return activeColumns.filter((column) => staticTableColumns.includes(column));
    };
    (0, react_1.useEffect)(() => {
        // remove dynamic columns on organization change
        const organizationAgnosticColumns = getCacheableColumns(activeColumns);
        setActiveColumns(organizationAgnosticColumns);
    }, [organizations]);
    const handleSetActiveColumns = (0, react_1.useCallback)((activeCols) => {
        setActiveColumns(activeCols);
        // omitting dynamic columns (e.g. attributes) from cache
        const cacheableColumns = getCacheableColumns(activeCols);
        ls.setItem(lsKey, { 'data': cacheableColumns });
    }, [lsKey]);
    (0, react_1.useEffect)(() => {
        var _a;
        const receivedActiveColumns = (_a = ls.getItem(lsKey)) === null || _a === void 0 ? void 0 : _a.data;
        if (Array.isArray(receivedActiveColumns)) {
            setActiveColumns(receivedActiveColumns);
        }
    }, [lsKey]);
    return {
        activeColumns,
        columns,
        defaultColumns,
        handleSetActiveColumns,
    };
};
exports.useRefineModal = useRefineModal;
